import Font from "@/src/components/base/Font";
import styles from "./index.module.scss";
import { useEffect, useRef, useState } from "react";
import Button from "@/src/components/elements/Button";
import { useRouter } from "next/router";
import PointLine3 from "@/src/components/icons/PointLine3";
import PointLine4 from "@/src/components/icons/PointLine4";
import { CallToAction } from "@/src/utils/types/landingpage";

export default function LandingCallToAction({
  callToAction
}: {
  callToAction: CallToAction[];
}) {
  const router = useRouter()
  const illustrationRef = useRef(null);
  const titleRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
    };

    const callback: IntersectionObserverCallback = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles["visible"]);
          observer.unobserve(entry.target)
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
  
    if (illustrationRef.current) {
      observer.observe(illustrationRef.current);
    }
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }
    if (buttonRef.current) {
      observer.observe(buttonRef.current);
    }
    // Clean up
    return () => {
      observer.disconnect();
    };
  }, [
    illustrationRef,
    titleRef,
    buttonRef,
  ]);
  
  const handleAction = () => {
    const url = callToAction?.find(cta => cta.nama_cta = "formulir")?.link_cta
    if (url) {
      router.push(url)
    }
  }
  
  return (
    <div className={styles["main-service-section"]}>
      <div className={styles["square-orange-1-wrapper"]} />
      <div className={styles["square-blue-2-wrapper"]} />
      <div className={styles["point-line-1"]}>
        <PointLine3 />
      </div>
      <div className={styles["content"]}>
        <img
          ref={illustrationRef}
          className={styles["illustration"]}
          src={`${process.env.NEXT_PUBLIC_IMAGES}/characters-standing-illustration.svg`}
        />
        <div
          ref={titleRef}
          className={styles["main-service-title"]}
        >
          <Font variant="title-4-bold" color="black" align="center">
            Tertarik Berkolaborasi dengan BRIBrain?
          </Font>
          <Font variant="subtitle-2-medium" color="dark40" align="center">
            Silakan isi formulir kolaborasi di bawah ini
          </Font>
        </div>
        <div
          ref={buttonRef}
          className={styles["button-action"]}
        >
          <Button
            size="medium"
            text={callToAction?.find(cta => cta.nama_cta = "formulir")?.deskripsi_cta}
            onClick={handleAction}
          />
        </div>
      </div>
    </div>
  );
}
